import * as React from "react";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import {
  Form,
  EditBase,
  useEditContext,
  useRefresh,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Loader } from "../Views/Loader";

const SubmitForm = ({ handleClose, children, resource, id }) => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const { save } = useEditContext();
  const notify = useNotify();

  const [loading, setLoading] = React.useState(false);

  // Define messages based on resource
  const successMessages = {
    GameCatalogue: "Game edited successfully!",
    users: "Password Reset successfully!",
  };

  const handleSubmit = async (data) => {
    setLoading(true);

    const payload = {
      ...data,
      objectId: id,
    };

    try {
      const response = await dataProvider.update(resource, {
        data: payload,
      });

      if (response) {
        notify(successMessages[resource] || "Operation successful!", {
          type: "success",
        });

        handleClose();
        refresh();
      }
    } catch (error) {
      notify(error.message, { type: "error" });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <Loader />}
      <Form
        noValidate
        onSubmit={handleSubmit}
        sx={{ mt: 3, alignSelf: "stretch" }}
      >
        {children}
      </Form>
    </>
  );
};

export const EditForm = ({ title, handleClose, id, resource, children }) => {
  return (
    <EditBase resource={resource} id={id} redirect={false}>
      <Container component="overlay" maxWidth="sm" sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            // alignItems: 'center',
            "& .MuiInputLabel-root": {
              textAlign: "left",
              fontSize: "0.75em",
            },
            "& .MuiButton-root": { textTransform: "capitalize" },
            "& .MuiGrid-item": {
              // display: "flex",
              // flexDirection: "row",
              gap: 1,
              // alignItems: "center",
              // justifyContent: "flex-end"
            },
            "& .MuiTextField-root": {
              flexBasis: "80%",
              alignItems: "stretch",
            },
            "& .MuiNumberField-root": {
              flexBasis: "80%",
              alignItems: "stretch",
            },
          }}
        >
          <Typography component="h1" variant="h6" sx={{ mb: 3 }}>
            {title}
          </Typography>
          <SubmitForm handleClose={handleClose} resource={resource} id={id}>
            <Grid container spacing={2}>
              {children}
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  sx={{
                    border: "1px solid rgba(255, 239, 153, 0.20)",
                    color: "#FFF",
                    "&:hover": {
                      border: "1px solid #fff",
                      background: "none",
                    },
                  }}
                  onClick={handleClose}
                >
                  cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: "#FFD700",
                    color: "#000",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: "#FFA000",
                    },
                  }}
                >
                  confirm
                </Button>
              </Grid>
            </Grid>
          </SubmitForm>
        </Box>
      </Container>
    </EditBase>
  );
};
